import { FormType, ReportJSON } from '@aloft/toolkit-shared';

import { scalarToNumberToString } from '../utils.ts';
import { createNodeWithText } from './utils.ts';

export function generateTotalXmlAdjustmentNodes(
  doc: XMLDocument,
  comp: ReportJSON['comps'][string],
  formType: FormType,
): HTMLElement[] {
  const adjustmentNodes = [];

  adjustmentNodes.push(
    createNodeWithText(doc, 'PR_SALEPR1', comp.salesGridData.annotations.PropertySalesAmount),
  );

  adjustmentNodes.push(
    createNodeWithText(
      doc,
      'FN_CONC1_ADJ',
      scalarToNumberToString(comp.salesGridData.adjustments?.SalesConcessions),
    ),
  );
  adjustmentNodes.push(
    createNodeWithText(
      doc,
      'FN_CONC2_ADJ',
      scalarToNumberToString(comp.salesGridData.adjustments?.FinancingConcessions),
    ),
  );

  adjustmentNodes.push(
    createNodeWithText(
      doc,
      'DT_SALTIM1_ADJ',
      scalarToNumberToString(comp.salesGridData.adjustments?.DateOfSale),
    ),
  );

  adjustmentNodes.push(
    createNodeWithText(
      doc,
      'ST_SITSIZE_ADJ',
      scalarToNumberToString(comp.salesGridData.adjustments?.SiteArea),
    ),
  );

  adjustmentNodes.push(
    createNodeWithText(
      doc,
      'DA_CONSTQL_ADJ',
      scalarToNumberToString(comp.salesGridData.adjustments?.Quality),
    ),
  );

  adjustmentNodes.push(
    createNodeWithText(
      doc,
      'AG_COND1_ADJ',
      scalarToNumberToString(comp.salesGridData.adjustments?.Condition),
    ),
  );

  adjustmentNodes.push(createNodeWithText(doc, 'AG_AGYRBLT_ADJ', scalarToNumberToString(0)));

  const bathroomLineNodeID = formType === FormType.fnma1025 ? 'UN_NUM1_ADJ' : 'RM_TOTAL_ADJ';
  adjustmentNodes.push(
    createNodeWithText(
      doc,
      bathroomLineNodeID,
      scalarToNumberToString(comp.salesGridData.adjustments?.RoomAboveGradeLine2),
    ),
  );

  const grossAreaNodeID = formType === FormType.fnma1025 ? 'SF_GBA_ADJ' : 'SF_GLA_ADJ';
  adjustmentNodes.push(
    createNodeWithText(
      doc,
      grossAreaNodeID,
      scalarToNumberToString(comp.salesGridData.adjustments?.GrossLivingArea),
    ),
  );

  adjustmentNodes.push(
    createNodeWithText(
      doc,
      'UN_NUM2_ADJ',
      scalarToNumberToString(comp.salesGridData.adjustments?.NumberOfUnits),
    ),
  );

  adjustmentNodes.push(
    createNodeWithText(
      doc,
      'BM_BSM1_ADJ',
      scalarToNumberToString(comp.salesGridData.adjustments?.BasementArea),
    ),
  );

  adjustmentNodes.push(
    createNodeWithText(
      doc,
      'BM_BSM2_ADJ',
      scalarToNumberToString(comp.salesGridData.adjustments?.BasementFinish),
    ),
  );

  adjustmentNodes.push(
    createNodeWithText(
      doc,
      'FU_FUNCTUT_ADJ',
      scalarToNumberToString(comp.salesGridData.adjustments?.FunctionalUtility),
    ),
  );

  adjustmentNodes.push(
    createNodeWithText(
      doc,
      'CR_GARPRK1_ADJ',
      scalarToNumberToString(comp.salesGridData.adjustments?.CarStorage),
    ),
  );

  adjustmentNodes.push(
    createNodeWithText(
      doc,
      'PF_PORPAT1_ADJ',
      scalarToNumberToString(comp.salesGridData.adjustments?.PorchDeck),
    ),
  );

  adjustmentNodes.push(createNodeWithText(doc, 'CM_OTHR1_TEXT', 'Add. Features'));
  adjustmentNodes.push(
    createNodeWithText(
      doc,
      'BL_BLANK1_ADJ',
      scalarToNumberToString(comp.salesGridData.adjustments?.OtherFeature1),
    ),
  );
  adjustmentNodes.push(
    createNodeWithText(
      doc,
      'BL_BLANK2_ADJ',
      scalarToNumberToString(comp.salesGridData.adjustments?.OtherFeature2),
    ),
  );
  adjustmentNodes.push(
    createNodeWithText(
      doc,
      'BL_BLANK3_ADJ',
      scalarToNumberToString(comp.salesGridData.adjustments?.OtherFeature3),
    ),
  );

  return adjustmentNodes;
}
